import React__default from 'react';
import './Hint.scss.js';
import Button from '../Button/Button.js';
import AllClose from '../../../assets/icons/resultDir/AllClose.js';
import StatusInfoFill from '../../../assets/icons/resultDir/StatusInfoFill.js';
import StatusError from '../../../assets/icons/resultDir/StatusError.js';
import StatusRelease from '../../../assets/icons/resultDir/StatusRelease.js';

var ICON_MAPPING = {
  'default': /*#__PURE__*/React__default.createElement(StatusInfoFill, {
    "data-v-6e52f9c7": ""
  }),
  'red': /*#__PURE__*/React__default.createElement(StatusError, {
    "data-v-6e52f9c7": ""
  }),
  'green': /*#__PURE__*/React__default.createElement(StatusRelease, {
    "data-v-6e52f9c7": ""
  }),
  'blue': /*#__PURE__*/React__default.createElement(StatusInfoFill, {
    "data-v-6e52f9c7": ""
  }),
  'yellow': /*#__PURE__*/React__default.createElement(StatusInfoFill, {
    "data-v-6e52f9c7": ""
  })
}; // FIXME: Elements must have sufficient color contrast

var Hint = function Hint(_ref) {
  var children = _ref.children,
      button = _ref.button,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      _ref$iconMapping = _ref.iconMapping,
      iconMapping = _ref$iconMapping === void 0 ? ICON_MAPPING : _ref$iconMapping,
      icon = _ref.icon,
      title = _ref.title,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '648px' : _ref$maxWidth,
      onClose = _ref.onClose;
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      maxWidth: maxWidth
    },
    className: "rf-hint rf-hint--".concat(variant),
    "data-v-6e52f9c7": ""
  }, icon !== false && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-hint__icon",
    "data-v-6e52f9c7": ""
  }, icon === undefined || typeof icon === 'string' ? iconMapping[variant] : icon), /*#__PURE__*/React__default.createElement("div", {
    className: "rf-hint__body",
    "data-v-6e52f9c7": ""
  }, title && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-hint__title",
    "data-v-6e52f9c7": ""
  }, title), children && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-hint__message",
    "data-v-6e52f9c7": ""
  }, " ", children, " "), button && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-hint__button",
    "data-v-6e52f9c7": ""
  }, button)), !!onClose && /*#__PURE__*/React__default.createElement(Button, {
    onClick: onClose,
    "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    startAdornment: /*#__PURE__*/React__default.createElement(AllClose, {
      size: "xxs",
      "data-v-6e52f9c7": ""
    }),
    buttonType: "text",
    textColor: "neutral",
    size: "xs",
    "data-v-6e52f9c7": ""
  }));
};

export { Hint as default };
